export const SETPENGADAAN = "SETPENGADAAN";
export const RESETPENGADAAN = "RESETPENGADAAN";
export const SETFILEBYID = "SETFILEBYID";
export const RESETFILEBYID = "RESETFILEBYID";